import { render } from "./PaymentDetailPage.vue?vue&type=template&id=be4a1bc6"
import script from "./PaymentDetailPage.vue?vue&type=script&lang=js"
export * from "./PaymentDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__